import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Inject, Injectable } from '@angular/core';
import { APP_ENV, EnvironmentBase } from '@environments/environment.base';
import { CounterDto, JobDto, ReadingViewModel } from '@lib-ui/client';

@Injectable()
export class LoggingService {
  appInsights: ApplicationInsights;

  constructor(@Inject(APP_ENV) private environment: EnvironmentBase) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true, // option to log all route changes
      },
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }

  logException(exception: Error, severityLevel?: number) {
    console.error(exception, severityLevel);
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  logError(message: string, exception?: any) {
    console.error(message, exception);
    this.appInsights.trackException({ exception: exception }, { message: message });
  }

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  logTrace(message: any, properties?: { [key: string]: any }) {
    let temp = message;
    console.log(message);
    if (Array.isArray(message) || typeof message === 'object') {
      temp = JSON.stringify(message);
    }
    this.appInsights.trackTrace({ message: temp }, properties);
  }

  public logJob(message: string, job: JobDto) {
    const firstMeter = job.meter;
    const concatenated = `counters=${firstMeter.counters!.map(x => x.id).join('/')}`;
    const prefix = `[Job ${job.id}]: `;
    const finalMessage = `${prefix} ${message} | ${concatenated}`;
    console.log(`%c ${finalMessage}`, 'color: green', job);
    this.logTrace(finalMessage, { job: job });
  }

  public logCounter(
    message: string,
    jobId: number | null,
    counter: CounterDto,
  ) {
    const concatenated = `id=${jobId}, readingId=${counter.lastReading!.id}, value=${
      counter.lastReading!.value
    }`;
    const prefix = `[Job ${jobId}]: `;
    const finalMessage = `${prefix} Counter: ${message} | ${concatenated}`;
    console.log(`%c ${finalMessage}`, 'color: yellow', counter);
    this.logTrace(finalMessage, { counter: counter });
  }

  public logReading(message: string, jobId: number, reading: ReadingViewModel) {
    const concatenated = `id=${reading.id}, value=${reading.value}, filename=${reading.fileName}`;
    const prefix = `[Job ${jobId}]: `;
    const finalMessage = `${prefix} Reading: ${message} | ${concatenated}`;
    console.log(`%c ${finalMessage}`, 'color: blue', reading);
    this.logTrace(finalMessage, { reading: reading });
  }
}
